// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showAllComment-38YqIz_7 {\n    padding-top: 30px;\n    text-align: center\n}\n.showAllComment-38YqIz_7 a {\n    display: inline-block;\n    width: 100%;\n    height: 27px;\n    line-height: 27px;\n    vertical-align: middle;\n    font-size: 14px;\n    color: #024375;\n    background: #f1f1f1;\n}\n", ""]);
// Exports
exports.locals = {
	"showAllComment": "showAllComment-38YqIz_7"
};
module.exports = exports;
